import { gql, TypedDocumentNode } from '@apollo/client';

import { BASE_TASK_ITEM } from '@atom/graph/task';
import { BASE_WORK_ORDER_FIELD } from '@atom/graph/work';
import {
  AppointmentConflictsConnection,
  AppointmentConflictsConnectionInput,
  AppointmentsConnection,
  MonthlyAppointmentsConnection,
} from '@atom/types/appointments';
import { WorkOrdersConnectionInput } from '@atom/types/work';

export const GET_APPOINTMENTS: TypedDocumentNode<
  { appointments: AppointmentsConnection },
  { input: WorkOrdersConnectionInput }
> = gql`
  query appointments($input: WorkOrdersConnectionInput!) {
    appointments(input: $input) {
      totalCount
      appointments {
        id
        type
        name
        originalName
        priorityId
        statusId
        reopened
        appointmentsEnabled
        plannedStartDate

        inventoryAssetId
        inventoryAssetName
        inventoryAssetSchemaId
        appliedDate

        workTemplateId
        workTemplate {
          id
          name
        }

        startTime
        duration
        dueDate
        completionDate
        completedBy {
          id
          firstName
          lastName
          email
          photoUrl
        }

        fields {
          ...BaseWorkOrderField
        }

        tasks {
          ...BaseTaskItem
        }

        createdDate
        createdBy {
          id
          firstName
          lastName
          email
          photoUrl
        }
      }
    }
  }
  ${BASE_TASK_ITEM}
  ${BASE_WORK_ORDER_FIELD}
`;

export const GET_MONTHLY_APPOINTMENTS: TypedDocumentNode<
  { monthlyAppointments: MonthlyAppointmentsConnection },
  { input: WorkOrdersConnectionInput }
> = gql`
  query monthlyAppointments($input: WorkOrdersConnectionInput!) {
    monthlyAppointments(input: $input) {
      totalCount
      appointments {
        date
        totalWorkOrderCount
        workOrders {
          id
          name
          statusId
          dueDate
          plannedStartDate
        }
      }
    }
  }
`;

export const GET_APPOINTMENT_CONFLICTS: TypedDocumentNode<
  { appointmentConflicts: AppointmentConflictsConnection },
  { input: AppointmentConflictsConnectionInput }
> = gql`
  query appointmentConflicts($input: AppointmentConflictsConnectionInput!) {
    appointmentConflicts(input: $input) {
      totalCount
      appointmentConflicts {
        user {
          id
          firstName
          lastName
        }
        workOrders {
          id
          name
          statusId
          dueDate
          plannedStartDate
        }
      }
    }
  }
`;
